import { getHighlightRowSizes } from './get-highlight-row-sizes';

// Literal classes, so Tailwind can see them. Keyed by how many cards share the row.
const COLUMN_SPAN_BY_ROW_SIZE: Record<number, string> = {
  1: 'md:col-span-12',
  2: 'md:col-span-6',
  3: 'md:col-span-4',
  4: 'md:col-span-3',
};

// The highlight rows on a 12-column grid.
export const getHighlightColumnSpans = (count: number) =>
  getHighlightRowSizes(count).flatMap((size) => Array.from({ length: size }, () => COLUMN_SPAN_BY_ROW_SIZE[size]));
